export var SUBORDINATED_BOND_DEFINITION_KEY = 'subordinatedBondDefinition';
export var SUBORDINATED_BOND_VARIATION_KEY = 'subordinatedBondVariation';
